import { render, staticRenderFns } from "./forgetPassword.vue?vue&type=template&id=66073286&scoped=true&"
import script from "./forgetPassword.vue?vue&type=script&lang=js&"
export * from "./forgetPassword.vue?vue&type=script&lang=js&"
import style0 from "./forgetPassword.vue?vue&type=style&index=0&id=66073286&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66073286",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66073286')) {
      api.createRecord('66073286', component.options)
    } else {
      api.reload('66073286', component.options)
    }
    module.hot.accept("./forgetPassword.vue?vue&type=template&id=66073286&scoped=true&", function () {
      api.rerender('66073286', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/viewsBlack/forgetPassword.vue"
export default component.exports